const insertRow = ({ object, items }) => [
  { ...object }, ...items
];

export default insertRow;
